import styled from '@emotion/styled'

import media from '../../../../../styles/media'
import { colors } from '../../../../../styles/theme'

const S = {}

S.MenuItemTitle = styled.div`
  position: relative;

  .menu-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    line-height: 0;

    html:not([dir]) &,
    [dir='ltr'] & {
      left: calc(100vw - 13%);

      ${media.sm`
        left: 15.75rem;
      `};
    }

    [dir='rtl'] & {
      right: calc(100vw - 13%);

      ${media.sm`
        right: 15.75rem;
      `};
    }
  }

  .menu-icon-chevron {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
    transition: transform 0.1s cubic-bezier(0.5, 0, 0.25, 1);

    path {
      fill: ${({ lightMode }) =>
        lightMode ? colors.shark : colors.silverChalice};
    }
  }
`

S.Submenu = styled.ul`
  list-style-type: none;
  padding-left: 0;
  padding-right: 0;
  margin: 0;

  .submenu-item-title {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: ${({ lightMode }) => (lightMode ? colors.shark : colors.silver)};
    line-height: 1.29;
    padding: 0.875rem 1.5rem 0.875rem 2.375rem;
    background-color: ${({ lightMode }) =>
      lightMode ? '#f2f2f2' : 'rgba(74, 78, 88, 0.5)'};

    @media (hover: hover) {
      &:hover {
        background-color: ${({ lightMode }) =>
          lightMode ? colors.white : colors.trout};
        color: ${({ lightMode }) => lightMode && colors.orange};
      }
    }

    &:active {
      background-color: ${({ lightMode }) => lightMode && '#dedede'};
    }

    &.active {
      color: ${({ lightMode }) => (lightMode ? colors.orange : colors.white)};
      border: 0 solid
        ${({ lightMode }) => (lightMode ? colors.orange : colors.scooter)};
      padding-left: 2.25rem;
      background-image: ${({ lightMode }) =>
        !lightMode &&
        'linear-gradient(to left, rgba(74, 78, 88, 0.5), rgba(74, 78, 88, 1))'};
      background-color: ${({ lightMode }) => lightMode && colors.white};

      html:not([dir]) &,
      [dir='ltr'] & {
        border-left-width: 0.125rem;
      }

      [dir='rtl'] & {
        border-right-width: 0.125rem;
      }
    }
  }
`

export default S
